import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { MultiSelectApi } from '../../Widgets/MultiSelect'
import { Utils } from '../../Utils/Utils';
import { DateUtils } from '../../Utils/DateUtils';
import { StringUtils } from '../../Utils/StringUtils';

var tableId = 'tableGameBuildConfigurations';
var buildSelectorTableId = 'tableBuildSelector';
var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";

var hashTypes = ["MD5", "SHA1", "SHA256"];

var COLUMN_INDEX = {
    GameCode: 1,
    Operation: 2,
    GameStatus: 3
}

var selectedType: string;
var FILTER_DELIM = '-delim-';
var selectedName: string;

export interface IndexPageOptions extends PageOptionsBase {
    urlList: string;
    urlDetail: string;
    urlPost: string;
    defaultHashButton: string;
    localizer: {
        StatusEnabled: string;
        StatusDisabled: string;
    }
}

export class BuildSelectionPage extends PageBase<IndexPageOptions> {
    private _tableOptions: DatatableOptions;
    private _table: Datatable;

    private _btnShowMd5: JQuery;
    private _btnShowSha1: JQuery;
    private _btnShowSha256: JQuery;

    private _btnSelectBuild: JQuery;

    private _chckAllBuilds: JQuery;

    private _form: JQuery;
    private _btnCancelSearch: JQuery;
    private _filterGame: MultiSelectApi;
    private _filterOperation: MultiSelectApi;
    private _filterGameStatus: MultiSelectApi;

    constructor(options: IndexPageOptions) {
        super(options);
        selectedType = options.defaultHashButton;
        this.showMd5 = this.showMd5.bind(this);
        this.showSha1 = this.showSha1.bind(this);
        this.showSha256 = this.showSha256.bind(this);
        this.drawCallback = this.drawCallback.bind(this);
        this.formSubmit = this.formSubmit.bind(this);
        this.cancelSearch = this.cancelSearch.bind(this);
        this.preDrawCallback = this.preDrawCallback.bind(this);
        this.detectSelectedGame = this.detectSelectedGame.bind(this);
        this.showBuildSelector = this.showBuildSelector.bind(this);
        this.checkBoxAll = this.checkBoxAll.bind(this);
        this.displayHash = this.displayHash.bind(this);

        window['detectSelectedGame'] = this.detectSelectedGame;
        window['setBuildsSelectAllCheckbox'] = this.setBuildsSelectAllCheckbox;

        // === prepare table options
        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            rowId: 'Id',
            autoWidth: true,
            columns: [
                {
                    sortable: false,
                    render: (data: any, type: any, rowData: any) => {
                        return (`<input id='chckbx${rowData.Id}' name='selectedBuild' value='${rowData.Id}' type='checkbox' onchange=detectSelectedGame() onClick="setBuildsSelectAllCheckbox()" />`);
                    }
                },
                {
                    sortable: false,
                    data: "GameCode",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnGameCode${rowData.Id}'>${data}</span>`)
                },
                {
                    sortable: false,
                    data: "CustomerOperationCode",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnCustomerOperationCode${rowData.Id}'>${rowData.CustomerCode} | ${data}</span>`)
                },
                {
                    sortable: false,
                    data: "GameStatus",
                    render: (data: any, type: any, rowData: any) => {
                        var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
                        var css = data === true ? 'status-enabled' : 'status-disabled';
                        return `<span id='spnGameStatus${rowData.Id}' class='${css}'>${text}</span>`;
                    }
                },
                {
                    sortable: false,
                    data: "SelectedModuleVersion",
                    render: (data: any, type: any, rowData: any) => {
                        var manifest = JSON.parse(rowData.SelectedStringContent);
                        var file = manifest.Files[0];
                        var md5 = "";
                        var sha1 = "";
                        var sha256 = "";
                        if (file.Hashes.hasOwnProperty("MD5")) {
                            md5 = file.Hashes['MD5'];
                        }
                        if (file.Hashes.hasOwnProperty("SHA1")) {
                            sha1 = file.Hashes['SHA1'];
                        }
                        if (file.Hashes.hasOwnProperty("SHA256")) {
                            sha256 = file.Hashes['SHA256'];
                        }
                        return `<span class='buildVersion-format' id='spnSelectedModuleVersion${rowData.Id}'>${data}</span>
                          <span id='spnSelectedModuleVersionMd5Hash' name="md5hash" class="hash-format" title="${md5}">${this.shortHash(md5)}</span>
                          <span id='spnSelectedModuleVersionSha1Hash' name="sha1hash" class="hash-format" title="${sha1}">${this.shortHash(sha1)}</span>
                          <span id='spnSelectedModuleVersionSha256Hash' name="sha256hash" class="hash-format" title="${sha256}">${this.shortHash(sha256)}</span>`;
                    }
                },
                {
                    orderable: false,
                    data: 'filterButtons',
                    defaultContent: '',
                    searchable: false,
                    sortable: false
                }
            ],
            callbacks: {
                drawCallback: this.drawCallback,
                preDrawCallback: this.preDrawCallback
            }
        };
    }

    init(): void {
        this._form = Utils.getJQueryById("formGameBuilConfigurations");
        this._btnCancelSearch = Utils.getJQueryById("btnCancelSearch");
        this._filterGame = new MultiSelectApi('filterGame');
        this._filterOperation = new MultiSelectApi('filterOperation');
        this._filterGameStatus = new MultiSelectApi('filterGameStatus');

        this._btnShowMd5 = Utils.getJQueryById("MD5button");
        this._btnShowMd5.on("click", this.showMd5);

        this._btnShowSha1 = Utils.getJQueryById("SHA1button");
        this._btnShowSha1.on("click", this.showSha1);

        this._btnShowSha256 = Utils.getJQueryById("SHA256button");
        this._btnShowSha256.on("click", this.showSha256);

        this._btnSelectBuild = Utils.getJQueryById("btnSelectBuild");
        this._btnSelectBuild.attr("disabled", 1);
        this._btnSelectBuild.on("click", this.showBuildSelector);

        this._chckAllBuilds = Utils.getJQueryById("buildSelectAll");
        this._chckAllBuilds.on("change", this.checkBoxAll);

        // == create 'new Datatable' instance
        this._table = new Datatable(tableId, this._tableOptions);

        // == attach to events
        // filter form submit -> redraw table
        this._form.on('submit', this.formSubmit);

        // cancel search click -> reset filter row values
        this._btnCancelSearch.on('click', this.cancelSearch);
    }

    private setBuildsSelectAllCheckbox(): void {
        var checkboxes = $("input[name='selectedBuild']");
        let buildSelectAll = Utils.getJQueryById("buildSelectAll")[0];
        if (Utils.isNullOrUndefined(buildSelectAll))
            return;
        let allCheckboxesChecked = false;
        for (var i = 0; i < checkboxes.length; i++) {
            allCheckboxesChecked = (<HTMLInputElement>checkboxes[i]).checked;
            if (!allCheckboxesChecked)
                break;
        }        
        (<HTMLInputElement>buildSelectAll).checked = allCheckboxesChecked;
    }

    private checkBoxAll(): void {
        var checkboxes = $("input[name='selectedBuild']");
        for (var i = 0; i < checkboxes.length; i++) {
            (<HTMLInputElement>checkboxes[i]).checked = (<HTMLInputElement>this._chckAllBuilds[0]).checked;
        }
        this.detectSelectedGame();
    }

    private cancelSearch(e: JQueryEventObject): void {
        this._filterGame.selectAll();
        this._filterOperation.selectAll();
        this._filterGameStatus.selectAll();
    }

    private formSubmit(e: JQueryEventObject): any {
        e.preventDefault();
        this._table.draw();
        return false;
    }

    private showMd5(): void {
        selectedType = "MD5";
        this.displayHash();
    }

    private showSha1(): void {
        selectedType = "SHA1";
        this.displayHash();
    }

    private showSha256(): void {
        selectedType = "SHA256";
        this.displayHash();
    }

    private displayHash(): void {
        hashTypes.forEach(type => {
            $(`span[name='${type.toLowerCase()}hash']`).toggle(selectedType === type);
            $(`#${type}button`).toggleClass("green", selectedType === type);
        });
    }

    private shortHash(hash : string): string {
        if (hash.length > 0) {
            return `${hash.substring(0, 4)}...${hash.substring(hash.length - 4)}`;
        }
        return "";
    }

    private drawCallback(datatable: DatatableApi): any {
        this.showHideSelectAllCheckboxes();
        this.displayHash();
    }

    private preDrawCallback(datatable: DatatableApi): any {
        (<HTMLInputElement>this._chckAllBuilds[0]).checked = false;
        this.showHideSelectAllCheckboxes();
        var filterGame = this._filterGame.isAllSelected() ? '' : this._filterGame.getSelectionValues(FILTER_DELIM);
        datatable.columns(COLUMN_INDEX.GameCode).search(filterGame);

        var filterCustomerOperation = this._filterOperation.isAllSelected() ? '' : this._filterOperation.getSelectionValues(FILTER_DELIM);
        datatable.columns(COLUMN_INDEX.Operation).search(filterCustomerOperation);

        var filterGameStatus = this._filterGameStatus.isAllSelected()? '' : this._filterGameStatus.getSelectionValues(FILTER_DELIM);
        datatable.columns(COLUMN_INDEX.GameStatus).search(filterGameStatus);

        return true;
    }

    private detectSelectedGame(): void {
        var ids = $("input[name='selectedBuild']:checked").map(function() {
            var val: string = $(this).val();
            return val.substring(0, val.indexOf("-"));
        });
        var unique = ids.toArray().filter((value, index, array) => array.indexOf(value) === index);
        if (unique.length === 1) {
            this._btnSelectBuild.removeAttr("disabled");
            selectedName = unique.join();
        }
        else {
            this._btnSelectBuild.attr("disabled", 1);
            selectedName = "";
        }
    }

    private showBuildSelector() {
        var buildSelectorTable = Utils.getJQueryById(buildSelectorTableId).DataTable();
        buildSelectorTable.draw();
        $('#buildSelector').removeAttr("hidden");
    }

    private showHideSelectAllCheckbox(selectAllButton: string, checkboxesIdentifier: string): void {
        let selectAllCheckbox = Utils.getJQueryById(selectAllButton)[0];
        if (Utils.isNullOrUndefined(selectAllCheckbox))
            return;
        var checkboxes = $(checkboxesIdentifier);
        if (checkboxes.length === 0) {
            (<HTMLInputElement>selectAllCheckbox).hidden = true;
        } else {
            (<HTMLInputElement>selectAllCheckbox).hidden = false;
        }
    }

    private showHideSelectAllCheckboxes(): void {
        this.showHideSelectAllCheckbox("buildSelectAll", "input[name='selectedBuild']");
    }
}


export class BuildSelectorPage extends PageBase<IndexPageOptions> {
    private _tableOptions: DatatableOptions;
    private _table: Datatable;

    constructor(options: IndexPageOptions) {
        super(options);

        this.preDrawCallback = this.preDrawCallback.bind(this);
        this.hideSelector = this.hideSelector.bind(this);
        this.selectBuild = this.selectBuild.bind(this);

        // === prepare table options
        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            rowId: 'StringVersion',
            autoWidth: true,
            columns: [
                {
                    sortable: false,
                    render: (data: any, type: any, rowData: any) => {
                        return (`<input type='radio' name='selectedVersion' id='spnRadioButton${rowData.StringVersion}' value='${rowData.StringVersion}' />`);
                    }
                },
                {
                    sortable: false,
                    data: "StringVersion",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnStringVersion${rowData.StringVersion}'>${data}</span>`)
                },
                {
                    sortable: false,
                    data: "StringContent",
                    render: (data: any, type: any, rowData: any) => {
                        var manifest = JSON.parse(rowData.StringContent);
                        var file = manifest.Files[0];
                        var md5 = "";
                        var sha1 = "";
                        var sha256 = "";
                        if (file.Hashes.hasOwnProperty("MD5")) {
                            md5 = file.Hashes['MD5'];
                        }
                        if (file.Hashes.hasOwnProperty("SHA1")) {
                            sha1 = file.Hashes['SHA1'];
                        }
                        if (file.Hashes.hasOwnProperty("SHA256")) {
                            sha256 = file.Hashes['SHA256'];
                        }
                        return `<table id='tblStringContent${rowData.StringVersion}' class='buildVersion-table'>
                                <tr><td>MD5: </td><td>${md5}</td></tr>
                                <tr><td>SHA1: </td><td>${sha1}</td></tr>
                                <tr><td>SHA256: </td><td>${sha256}</td></tr>
                                </table>`;
                    }
                },
                {
                    sortable: false,
                    data: "Created",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnCreated${rowData.StringVersion}'>${DateUtils.toDefaultWithTime(data)}</span>`)
                },
                {
                    sortable: false,
                    data: "Description",
                    render: (data: any, type: any, rowData: any) => {
                        var description = Utils.isNullOrUndefined(data) ? "" : data;
                        return `<span id='spnDescription${rowData.StringVersion}'>${description}</span>`;
                    }
                },
                {
                    sortable: false,
                    data: "IsEnabled",
                    render: (data: any, type: any, rowData: any) => {
                        var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
                        var css = data === true ? 'status-enabled' : 'status-disabled';
                        return `<span id='spnState${rowData.Id}' class='${css}'>${text}</span>`;
                    }
                },
                {
                    sortable: false,
                    data: "IsValid",
                    render: (data: any, type: any, rowData: any) => {
                        var css = data === true ? 'status-enabled' : 'status-disabled';
                        return `<span id='spnState${rowData.Id}' class='${css}'>${StringUtils.capitalizeFirstLetter(data.toString())}</span>`;
                    }
                }
            ],
            callbacks: {
                preDrawCallback: this.preDrawCallback
            }
        };
    }

    init(): void {
        const btnHideBuildSelector = Utils.getJQueryById("btnHideBuildSelector");
        btnHideBuildSelector.on("click", this.hideSelector);
        const btnSelectVersion = Utils.getJQueryById("btnSelectVersion");
        btnSelectVersion.on("click", this.selectBuild);
        this._table = new Datatable(buildSelectorTableId, this._tableOptions);
    }

    private preDrawCallback(datatable: DatatableApi): any {
        datatable.columns(1).search(selectedName);
        
        return true;
    }

    private hideSelector(): void {
        $('#buildSelector').attr("hidden", "hidden");
    }

    private selectBuild(): void {
        var urlPost = this._options.urlPost;
        var buildConfigurationTable = Utils.getJQueryById(tableId).DataTable();
        var ids = $("input[name='selectedBuild']:checked").map(function() {
            return $(this).val();
        });
        var idsToChange = ids.get();
        if (!idsToChange || idsToChange.length === 0) {
            this.hideSelector();
            return;
        }

        var selectedVersion = $("input[name='selectedVersion']:checked").map(function() {
            return $(this).val();
        })
        var versionToSet = selectedVersion.get();
        if (!versionToSet || versionToSet.length === 0) {
            this.hideSelector();
            return;
        }

        $.ajax({
            url: urlPost,
            type: "POST",
            dataType: 'html',
            data: { selectedGame: selectedName, ids: idsToChange, version: versionToSet[0] },
            success: function(data) {
                buildConfigurationTable.draw();
            }
        });
        this.hideSelector();
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/ConfigurationImport/BuildSelectionPage.ts
 **/